import React, { useState } from 'react'
import type { ReactNode } from 'react'
import {
  Box, useMediaQuery, Theme, IconButton
} from '@mui/material'
import { ChevronRight, MenuOpen } from '@mui/icons-material'
import NavBar from './NavBar'
import TopBar from './TopBar'

interface DashboardLayoutProps {
  children?: ReactNode
}

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const [isMobileNavOpen, setMobileNavOpen] = useState<boolean>(false)
  const [isNavCollapsed, setNavCollapsed] = useState<boolean>(false)
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'))

  return (
    <Box sx={{
      display: 'flex',
      overflow: 'hidden',
      width: '100%'
    }}
    >
      {!isNavCollapsed && <NavBar onMobileClose={() => setMobileNavOpen(false)} openMobile={isMobileNavOpen} />}
      {lgUp && (
        <IconButton
          onClick={() => setNavCollapsed(!isNavCollapsed)}
          sx={{
            position: 'fixed',
            left: isNavCollapsed ? 8 : 240,
            top: 72,
            zIndex: 1200,
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '50%',
            transition: 'left 0.2s ease, box-shadow 0.2s ease',
            '&:hover': {
              backgroundColor: 'background.paper',
              boxShadow: (theme) => `0 0 0 4px ${theme.palette.action.hover}`,
            },
          }}
        >
          {isNavCollapsed ? <ChevronRight /> : <MenuOpen />}
        </IconButton>
      )}

      <Box sx={{
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
        paddingLeft: lgUp && !isNavCollapsed ? '256px' : 0,
        transition: 'padding-left 0.2s ease',
      }}
      >
        <Box display="flex" flex="1 1 auto" overflow="hidden">
          <Box flex="1 1 auto" height="100%" overflow="hidden">
            <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default DashboardLayout
